<template>
    <div class="login-box">
        <div class="login-logo">
            <router-link to="/"><b>Admin</b> LTE</router-link>
        </div>
        <!-- /.login-logo -->
        <div class="login-box-body">
            <p class="login-box-msg">Inscrivez-vous</p>
            <form @submit.prevent="register">

                <div v-if="errors.length > 0" class="alert alert-danger">
                    <a class="close" data-dismiss="alert">&times;</a>
                    <ul>
                        <li v-for="error in errors">{{ error.code }}</li>
                    </ul>
                </div>

                <div v-if="success" class="alert alert-success">
                    <a class="close" data-dismiss="alert">&times;</a>
                    {{ success }}
                </div>

                <div class="form-group has-feedback">
                    <input type="email" class="form-control" placeholder="Email" v-model="credentials.email">
                    <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                    <input type="password" class="form-control" placeholder="Mot de passe" v-model="credentials.password">
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                    <input type="password" class="form-control" placeholder="Confirmer le mot de passe" v-model="credentials.confirmPassword">
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                    <input type="text" class="form-control" placeholder="Prénom" v-model="credentials.firstName">
                    <span class="glyphicon glyphicon-user form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                    <input type="text" class="form-control" placeholder="Nom" v-model="credentials.lastName">
                    <span class="glyphicon glyphicon-user form-control-feedback"></span>
                </div>
                <div class="row">
                    <div class="col-xs-8">
                        <router-link :to="{name: 'login'}">Connexion</router-link>
                    </div>
                    <!-- /.col -->
                    <div class="col-xs-4">
                        <button type="submit" class="btn btn-primary btn-block btn-flat">Inscription</button>
                    </div>
                    <!-- /.col -->
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Register',
    data: function () {
      return {
        credentials: {
          email: '',
          password: '',
          confirmPassword: '',
          firstName: '',
          lastName: ''
        },
        success: '',
        errors: []
      }
    },
    methods: {
      register: function () {
        this.$http.post('http://ws.ojssymphonique.net/api/register', {
          email: this.credentials.email,
          password: this.credentials.password,
          firstname: this.credentials.firstName,
          lastname: this.credentials.lastName,
          password_confirmation: this.credentials.confirmPassword
        }).then((response) => {
          if (response.body.success) {
            this.success = 'Inscription réussie, merci d\'attendre la validation de l\'administrateur'
          }
        }).catch((response) => {
          if (response.status === 422) {
            this.errors = response.body.errors
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?37f7022b